var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorksIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 15L16.25 13.75L14.375 15V24.375C14.375 25.4106 15.2145 26.25 16.25 26.25H25C26.0356 26.25 26.875 25.4106 26.875 24.375V22.5H25.625V15L23.75 13.75L21.875 15L20 13.75L18.125 15ZM24.375 22.5H16.875V24.375C16.875 24.7202 16.5952 25 16.25 25C15.9048 25 15.625 24.7202 15.625 24.375V15.669L16.25 15.2523L18.125 16.5023L20 15.2523L21.875 16.5023L23.75 15.2523L24.375 15.669V22.5ZM25 25H18.0183C18.0874 24.8045 18.125 24.5941 18.125 24.375V23.75H25.625V24.375C25.625 24.7202 25.3452 25 25 25Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksIcon4);
export default __webpack_public_path__ + "static/media/works_icon4.e3463768fdf5fb378ec3b3af82695ff5.svg";
export { ForwardRef as ReactComponent };